import { Routes, Route } from "react-router-dom";
import { OSCI0406001Q } from "../mgmt/intf/OSCI0406001Q";
import { OSCI0406002Q } from "../mgmt/intf/OSCI0406002Q";
import { OSCI0406003Q } from "../mgmt/intf/OSCI0406003Q";
import { OSCI0406004Q } from "../mgmt/intf/OSCI0406004Q";
import { OSCI0406005Q } from "../mgmt/gfs/OSCI0406005Q";
import { OSCI0406006Q } from "../mgmt/gfs/OSCI0406006Q";
import { OSCI0406007S } from "../mgmt/gfs/OSCI0406007S";
import { OSCI0406008S } from "../mgmt/gfs/OSCI0406008S";
import { OSCI0406009Q } from "../mgmt/intf/OSCI0406009Q";
import { OSCI0406010Q } from "../mgmt/intf/OSCI0406010Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const IntfRouter = () => {
    return (
        <Routes>
            <Route path="/osci0406001q" element={<OSCI0406001Q />} />
            <Route path="/osci0406002q" element={<OSCI0406002Q />} />
            <Route path="/osci0406003q" element={<OSCI0406003Q />} />
            <Route path="/osci0406004q" element={<OSCI0406004Q />} />
            <Route path="/osci0406005q" element={<OSCI0406005Q />} />
            <Route path="/osci0406006q/:gfsCd" element={<OSCI0406006Q />} />
            <Route path="/osci0406007s" element={<OSCI0406007S />} />
            <Route path="/osci0406008s" element={<OSCI0406008S />} />
            <Route path="/osci0406009q" element={<OSCI0406009Q />} />
            <Route path="/osci0406010q/:rqstId" element={<OSCI0406010Q />} />
        </Routes>
    );
};
